import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Web\CsrfCookieController::__invoke
* @see Http/Controllers/Web/CsrfCookieController.php:13
* @route '/csrf-cookie'
*/
const CsrfCookieController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: CsrfCookieController.url(options),
    method: 'get',
})

CsrfCookieController.definition = {
    methods: ["get","head"],
    url: '/csrf-cookie',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Web\CsrfCookieController::__invoke
* @see Http/Controllers/Web/CsrfCookieController.php:13
* @route '/csrf-cookie'
*/
CsrfCookieController.url = (options?: RouteQueryOptions) => {
    return CsrfCookieController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Web\CsrfCookieController::__invoke
* @see Http/Controllers/Web/CsrfCookieController.php:13
* @route '/csrf-cookie'
*/
CsrfCookieController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: CsrfCookieController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\CsrfCookieController::__invoke
* @see Http/Controllers/Web/CsrfCookieController.php:13
* @route '/csrf-cookie'
*/
CsrfCookieController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: CsrfCookieController.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Web\CsrfCookieController::__invoke
* @see Http/Controllers/Web/CsrfCookieController.php:13
* @route '/csrf-cookie'
*/
const CsrfCookieControllerForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: CsrfCookieController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\CsrfCookieController::__invoke
* @see Http/Controllers/Web/CsrfCookieController.php:13
* @route '/csrf-cookie'
*/
CsrfCookieControllerForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: CsrfCookieController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\CsrfCookieController::__invoke
* @see Http/Controllers/Web/CsrfCookieController.php:13
* @route '/csrf-cookie'
*/
CsrfCookieControllerForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: CsrfCookieController.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

CsrfCookieController.form = CsrfCookieControllerForm

export default CsrfCookieController